export enum TimelineItemType {
  alarm = 'alarm',
  phase = 'phase',
  start = 'start',
  field = 'field',
  userAnnotation = 'userAnnotation',
  additional = 'additional',
}